import { Landmark, Wallet, Banknote } from "lucide-react";
import visaLogo from "src/assets/images/payment/visa.svg";
import mastercardLogo from "src/assets/images/payment/mastercard.svg";
import amexLogo from "src/assets/images/payment/amex.svg";
import paypalLogo from "src/assets/images/payment/paypal.png";
import upiLogo from "src/assets/images/payment/upi.jpg";
import dinersLogo from "src/assets/images/payment/diners.svg";
import applePayLogo from "src/assets/images/payment/applepay.png";

// The payment methods a seller can advertise in their storefront footer.
// Kept in sync (by hand) with theme-settings' client/lib/paymentMethods.tsx
// so the toggle UI and the storefront render identical icons.
//
// "kind" controls how PaymentMethodsRow renders each entry:
//  - "logo": the real official logo. Visa/Mastercard/Diners sourced from the
//    "payment-icons" npm package (MPL-2.0, see
//    src/assets/images/payment/LICENSE-payment-icons.txt); Amex/PayPal/UPI/
//    Apple Pay are official brand artwork, shown to indicate accepted
//    payment methods (standard nominative use)
//  - "generic": not a single brand, just a payment category — a plain
//    lucide-react icon
export const PAYMENT_METHODS = [
  { id: "visa", label: "Visa", kind: "logo", logo: visaLogo },
  { id: "mastercard", label: "Mastercard", kind: "logo", logo: mastercardLogo },
  { id: "amex", label: "American Express", kind: "logo", logo: amexLogo },
  { id: "paypal", label: "PayPal", kind: "logo", logo: paypalLogo },
  { id: "applepay", label: "Apple Pay", kind: "logo", logo: applePayLogo },
  { id: "upi", label: "UPI", kind: "logo", logo: upiLogo },
  { id: "diners", label: "Diners Club", kind: "logo", logo: dinersLogo },
  { id: "netbanking", label: "Netbanking", kind: "generic", Icon: Landmark },
  { id: "wallets", label: "Wallets", kind: "generic", Icon: Wallet },
  { id: "cod", label: "Cash on Delivery", kind: "generic", Icon: Banknote },
];

export const PAYMENT_METHOD_MAP = PAYMENT_METHODS.reduce((acc, m) => {
  acc[m.id] = m;
  return acc;
}, {});
